import React, {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";

function Navbar() {

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1400) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll)
        };
    }, []);


    const navbarClass = scrolled
        ? "navbar navbar-expand-lg navbar-light fixed-top py-3 bg-orange"
        : "navbar navbar-expand-lg navbar-light fixed-top py-3";

    return (
        <nav className={navbarClass} id="mainNav">
            <div className="container px-4 px-lg-5">
                <a className="navbar-brand" href="#page-top">Selçuk YAPICI</a>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarResponsive">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ms-auto my-2 my-lg-0">
                        <li className="nav-item"><a className="nav-link" href="#about">Kimim ben</a></li>
                        <li className="nav-item"><a className="nav-link" href="#certificates">Daha iyiye giderken</a>
                        </li>
                        <li className="nav-item"><a className="nav-link" href="#services">Ne iş yaparım</a></li>
                        <li className="nav-item"><a className="nav-link" href="#portfolio">Ayinesi iştir kişinin</a>
                        </li>
                        <li className="nav-item"><a className="nav-link" href="#contact">Tanış olalım</a></li>
                        <li className="nav-item"><a className="nav-link"
                                                    href="https://mutfak.selcukyapici.com.tr">Mutfak</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
